import { useQueryClient } from '@tanstack/react-query'
import { LoadingState } from '@cinesend/ui-kit'
import FieldValue from '../field_value'
import SettingsCard from '../settings_card'
import { isImageField, isMediaField } from './field_groups'
import { useNonLocalizableFields } from './use_non_localizable_fields'

const GlobalMetadata = ({ asset, cycleID }) => {
  const queryClient = useQueryClient()
  const { fields, cacheKeys, isLoading } = useNonLocalizableFields(asset.id, cycleID)
  const refreshValues = () => cacheKeys.forEach((key) => queryClient.invalidateQueries(key))

  if (isLoading) {
    return (
      <SettingsCard title='Global metadata'>
        <LoadingState className='justify-center' />
      </SettingsCard>
    )
  }

  const visibleFields = fields.filter(({ field }) => !isMediaField(field) && !isImageField(field))
  if (visibleFields.length === 0) return null

  return (
    <SettingsCard title='Global metadata' description='Non-localizable catalog fields for this asset.'>
      <div className='grid gap-4 sm:grid-cols-2'>
        {visibleFields.map(({ field, cacheKey }) => (
          <div key={field.id} id={`field-${field.name?.toLowerCase()?.replaceAll(' ', '-')}`}>
            <FieldValue
              cacheKey={cacheKey}
              field={field}
              assetID={asset.id}
              cycleID={cycleID}
              refreshValues={refreshValues}
            />
          </div>
        ))}
      </div>
    </SettingsCard>
  )
}

export default GlobalMetadata
